export default __webpack_public_path__ + "static/media/Layer3.d9590422.png";